import { render } from "./BarcodeUnpairScan.vue?vue&type=template&id=2b8ff656&scoped=true"
import script from "./BarcodeUnpairScan.vue?vue&type=script&lang=ts"
export * from "./BarcodeUnpairScan.vue?vue&type=script&lang=ts"

import "./BarcodeUnpairScan.vue?vue&type=style&index=0&id=2b8ff656&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b8ff656"

export default script